import React from 'react';

export default function FormInputCheckbox({labelClassName, className, id, name, label, value, ...other}) {
	return <div className={`input-checkbox__wrapper ${className ? className : ''}`}>
		<label className={`input-checkbox__label ${labelClassName}`} htmlFor={id}>
			{label}
		</label>
		<input className={`input-checkbox__input`} checked={value} type="checkbox" name={name} id={id} {...other}/>
		<span className={`input-checkbox-custom`}/>
	</div>
}
